import { findKey, mapKeys } from "lodash";
import { ANALYSIS_CLASSIFICATION } from "../../consts";

const getJoeStatus = joeStrategy => {
  const joeThreatStatusOptions = [
    "malicious",
    "suspicious",
    "clean",
    "unknown"
  ];
  let joeThreatStatus = "";
  mapKeys(joeStrategy, (val, key) => {
    if (joeThreatStatusOptions.includes(key)) {
      if (val === true) {
        joeThreatStatus =
          key === "clean" ? ANALYSIS_CLASSIFICATION.GOODWARE : key;
      }
    }
  });
  return joeThreatStatus;
};

const prepareJoeResult = data => {
  if (!data.length) return null;

  const joeResultKey = findKey(data, o => o.key === "signature_detections");
  const joeErrorKey = findKey(data, o => o.key === "error_info");

  if (joeResultKey) {
    return getJoeStatus(data[joeResultKey]?.value?.strategy[1]);
  }

  if (joeErrorKey) return "Analysis failed";
  return null;
};

export { prepareJoeResult };
